import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ConfirmationModal.css';
import Button from './Button';

const ConfirmationModal = props => {
  const { isOpen, actionType, onClose, onConfirm, isLoading } = props;

  // Stan lokalny dla typu zwrotu (domyślnie 'none')
  const [refundType, setRefundType] = useState('none');

  if (!isOpen) return null;

  const isCompleteAction = actionType === 'complete';

  const handleConfirm = () => {
    if (isCompleteAction) {
      onConfirm({ refund: refundType });
    } else {
      onConfirm();
    }
  };

  return (
    <div className={css.modalOverlay} onClick={onClose}>
      <div className={css.modalContent} onClick={e => e.stopPropagation()}>
        <h3 className={css.title}>
          <FormattedMessage id={`ConfirmationModal.title.${actionType}`} />
        </h3>

        <p className={css.description}>
          <FormattedMessage id={`ConfirmationModal.description.${actionType}`} />
        </p>

        {isCompleteAction && (
          <div className={css.refundSection}>
            <p className={css.refundTitle}>
              <FormattedMessage id="ConfirmationModal.refundTitle" />
            </p>

            <div className={css.refundOptions}>
              <label className={classNames(css.refundCard, { [css.selected]: refundType === 'none' })}>
                <input
                  type="radio"
                  value="none"
                  className={css.hiddenRadio}
                  checked={refundType === 'none'}
                  onChange={e => setRefundType(e.target.value)}
                />
                <div className={css.cardContent}>
                  <div className={css.cardHeader}>
                    <strong className={css.cardLabel}><FormattedMessage id="ConfirmationModal.refundNone" /></strong>
                    {refundType === 'none' && <span className={css.checkMark}>✓</span>}
                  </div>
                  <span className={css.cardDesc}><FormattedMessage id="ConfirmationModal.refundNoneDesc" /></span>
                </div>
              </label>

              <label className={classNames(css.refundCard, { [css.selected]: refundType === 'last-payment' })}>
                <input
                  type="radio"
                  value="last-payment"
                  className={css.hiddenRadio}
                  checked={refundType === 'last-payment'}
                  onChange={e => setRefundType(e.target.value)}
                />
                <div className={css.cardContent}>
                  <div className={css.cardHeader}>
                    <strong className={css.cardLabel}><FormattedMessage id="ConfirmationModal.refundLast" /></strong>
                    {refundType === 'last-payment' && <span className={css.checkMark}>✓</span>}
                  </div>
                  <span className={css.cardDesc}><FormattedMessage id="ConfirmationModal.refundLastDesc" /></span>
                </div>
              </label>

              <label className={classNames(css.refundCard, { [css.selected]: refundType === 'prorate' })}>
                <input
                  type="radio"
                  value="prorate"
                  className={css.hiddenRadio}
                  checked={refundType === 'prorate'}
                  onChange={e => setRefundType(e.target.value)}
                />
                <div className={css.cardContent}>
                  <div className={css.cardHeader}>
                    <strong className={css.cardLabel}><FormattedMessage id="ConfirmationModal.refundProrate" /></strong>
                    {refundType === 'prorate' && <span className={css.checkMark}>✓</span>}
                  </div>
                  <span className={css.cardDesc}><FormattedMessage id="ConfirmationModal.refundProrateDesc" /></span>
                </div>
              </label>
            </div>
          </div>
        )}

        <div className={css.actions}>
          <Button onClick={onClose} isLoading={isLoading} variant="secondary">
            <FormattedMessage id="ConfirmationModal.btnCancel" />
          </Button>
          <Button onClick={handleConfirm} isLoading={isLoading}>
            {isLoading ? '...' : <FormattedMessage id={`ConfirmationModal.btnConfirm.${actionType}`} />}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal